import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// Don't forget to update CONNECT_ROUTES_SET in @jira/platform__common-constants/src/spa-routes
export const connectGeneralInvalidRoute: InvariantJiraRoute = {
	name: 'connect-general-invalid',
	path: '/plugins/servlet/ac/:addonKey//:moduleKey',
	// must be in sync with com.atlassian.jira.web.filters.frontend.ConnectGeneralPagesFrontendRoute::matchesRequest
	query: [
		'mobile?!=true',
		'includeWebResources?!=true',
		'classifier?!=json',
		'project.key?',
		'project.id?',
	],
};
